// extracted by mini-css-extract-plugin
export default {"container":"ProvinceManagement_container__wVFMJ"};